import React from "react";
import { ReactComponent as HouseIcon } from "./house-icon.svg";

const House = ({ ...rest }) => {
  return <HouseIcon {...rest} />;
};

export default House;
